import React from "react";

export default function SidebarTabList(props) {

  return <ul role="tablist">{props.children}</ul>;
}
